/**
 * Test if two arrays of simple types are equal
 */
export function arraysEqual(array1: (string | number | boolean)[], array2: (string | number | boolean)[]): boolean {
  return (
    Array.isArray(array1) &&
    Array.isArray(array2) &&
    array1.length === array2.length &&
    array1.every((value, i) => value === array2[i])
  );
}
